buyBonusPopup = {};

buyBonusPopup.infoText = undefined;
buyBonusPopup.open = false;

buyBonusPopup.show = function (callback) {
  buyBonusPopup.open = true;

  buyBonusPopup.freeSpinsButton.enableButton(true);

  buyBonusPopup.closeButton.enableButton(true);

  messageBus.post('game:modal', { reason: 'buy_bonus' });

  const freeSpinsStakes = buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY.coinSizes;

  // combine all the stakes and remove duplicates - then sort
  // this might all go wrong with stake indexes as some stakes will only be in one mode and not the other
  buyBonusPopup.allStakesCombined = freeSpinsStakes;
  buyBonusPopup.allStakesCombined.sort(function (a, b) {
    return a - b;
  });

  // if the buy a bonus default stakes are different we choose the lowest of the two - game design
  const fsDefault = buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY.defaultAmountPerLine;
  let defaultToUse = fsDefault;

  // if (superFreeSpinsDefault !== fsDefault) {
  //   console.log('WARNING: Default buy a bonus stakes differ between modes');
  //   defaultToUse = Math.min(superFreeSpinsDefault, fsDefault);
  // }

  // let defaultIndex = buyBonusPopup.allStakesCombined.indexOf(defaultToUse);
  // buyBonusPopup.combinedStakeIndex = defaultIndex;

  const bonusBuyStakes = buyBonusPopup.allStakesCombined;
  const crtBaseStake = gameController.globalHelperGetBaseStake();
  const stakeController = resourceManager.getController('stakeController');
  const numLines = stakeController.CurrentWinLineCount;

  const index = bonusBuyStakes.findIndex((stake) => stake * numLines === crtBaseStake);

  if (index !== -1) {
    buyBonusPopup.combinedStakeIndex = index;
  } else {
    buyBonusPopup.combinedStakeIndex = bonusBuyStakes.length - 1;
  }

  buyBonusPopup.updatePopup();

  resourceManager.getContainer('buyABonusContainer').visible = true;
  buyBonusPopup.container.visible = true;
  buyBonusPopup.callback = callback;
};

buyBonusPopup.updatePopup = function () {
  if (buyBonusPopup.combinedStakeIndex === -1) {
    // Something went really wrong here. No compatible stakes found
    buyBonusPopup.stakePreviousButton.enableButton(false);
    buyBonusPopup.stakeNextButton.enableButton(false);
    buyBonusPopup.freeSpinsButton.enableButton(false);
  } else {
    const bonusBuyStakes = buyBonusPopup.allStakesCombined;

    // update the stake buttons
    buyBonusPopup.stakePreviousButton.enableButton(buyBonusPopup.combinedStakeIndex > 0);
    buyBonusPopup.stakeNextButton.enableButton(buyBonusPopup.combinedStakeIndex < bonusBuyStakes.length - 1);

    // update the base stake box
    let baseStake = buyBonusPopup.convertToTotalStake(bonusBuyStakes[buyBonusPopup.combinedStakeIndex]);
    buyBonusPopup.baseStakeText.setText(gdk.formatCurrency(baseStake));

    // check stake is valid for each buy a bonus mode
    const freeSpinsStakes = buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY.coinSizes;
    const stakeToFind = bonusBuyStakes[buyBonusPopup.combinedStakeIndex];

    let freeSpinsStakeExists = freeSpinsStakes.includes(stakeToFind);

    // Free spins costs
    let costFreeSpins = baseStake * buyBonusPopup.gameConfig.data.buyBonusCost;
    buyBonusPopup.freeSpinsCostValue.setText(gdk.formatCurrency(costFreeSpins));
    buyBonusPopup.freeSpinsButton.enableButton(buyBonusPopup.balance >= costFreeSpins && freeSpinsStakeExists);
  }
};

buyBonusPopup.create = function (json) {
  return new PIXI.Container();
};

buyBonusPopup.convertToTotalStake = function (coinSize) {
  const stakeController = resourceManager.getController('stakeController');
  const numLines = stakeController.CurrentWinLineCount;

  return coinSize * numLines;
};

buyBonusPopup.onStakeNextPressed = function () {
  soundManager.play('buttonPressed');

  const bonusBuyStakes = buyBonusPopup.allStakesCombined;
  buyBonusPopup.combinedStakeIndex = Math.min(buyBonusPopup.combinedStakeIndex + 1, bonusBuyStakes.length - 1);
  buyBonusPopup.updatePopup();
};

buyBonusPopup.onStakePreviousPressed = function () {
  soundManager.play('buttonPressed');

  buyBonusPopup.combinedStakeIndex = Math.max(buyBonusPopup.combinedStakeIndex - 1, 0);
  buyBonusPopup.updatePopup();
};

buyBonusPopup.initialise = function (json, container) {
  buyBonusPopup.container = container;
  buyBonusPopup.container.visible = false;

  // buyBonusPopup.fadedMask = new PIXI.Graphics();
  // buyBonusPopup.fadedMask.beginFill(0, 0.8);
  // buyBonusPopup.fadedMask.drawRect(-10000, -10000, 20000, 20000);
  // buyBonusPopup.fadedMask.endFill();
  // buyBonusPopup.container.addChild(buyBonusPopup.fadedMask);
  messageBus.subscribe('spinner:GameConfigEvent', buyBonusPopup.onGameConfig);
  messageBus.subscribe('common:BalanceEvent', buyBonusPopup.onBalanceEvent);
  messageBus.subscribe('game:modal', buyBonusPopup.onModal);

  buyBonusPopup.helpActive = false;
};

buyBonusPopup.onModal = function (data) {
  if (buyBonusPopup.container.visible) {
    if (data.reason && data.reason === 'Options menu open') {
      buyBonusPopup.helpActive = true;

      buyBonusPopup.freeSpinsButton.enableButton(false);
      buyBonusPopup.closeButton.enableButton(false);
      //buyBonusPopup.infoButton.enableButton(false);

      // update the stake buttons
      buyBonusPopup.stakePreviousButton.enableButton(false);
      buyBonusPopup.stakeNextButton.enableButton(false);
    } else if (buyBonusPopup.helpActive) {
      buyBonusPopup.helpActive = false;

      buyBonusPopup.freeSpinsButton.enableButton(true);
      buyBonusPopup.closeButton.enableButton(true);
      //buyBonusPopup.infoButton.enableButton(true);

      buyBonusPopup.updatePopup();
    }

    if (buyBonusPopup.open) {
      if (data.reason === undefined) {
        messageBus.post('game:modal', { reason: 'buy_bonus' });
      }
    }
  }
};

buyBonusPopup.init = function () {
  buyBonusPopup.background = resourceManager.get('buyABonusContainer:buyBonusPopup:buyABonusBackground');

  buyBonusPopup.freeSpinsButton = resourceManager.get('buyABonusContainer:buyBonusPopup:buyABonusBackground:buyButton');
  buyBonusPopup.freeSpinsButton.onPressedCallback = buyBonusPopup.onClickedFreeSpins;
  buyBonusPopup.closeButton = resourceManager.get('buyABonusContainer:buyBonusPopup:buyABonusBackground:closeButton');
  buyBonusPopup.closeButton.onPressedCallback = buyBonusPopup.onClickedNo;
  buyBonusPopup.stakePreviousButton = resourceManager.get(
    'buyABonusContainer:buyBonusPopup:buyABonusBackground:stakePrevious'
  );
  buyBonusPopup.stakePreviousButton.onPressedCallback = buyBonusPopup.onStakePreviousPressed;
  buyBonusPopup.stakeNextButton = resourceManager.get('buyABonusContainer:buyBonusPopup:buyABonusBackground:stakeNext');
  buyBonusPopup.stakeNextButton.onPressedCallback = buyBonusPopup.onStakeNextPressed;
  buyBonusPopup.baseStakeText = resourceManager.get(
    'buyABonusContainer:buyBonusPopup:buyABonusBackground:buyABonusTextContainer:baseStakeText'
  );
  buyBonusPopup.freeSpinsCostValue = resourceManager.get(
    'buyABonusContainer:buyBonusPopup:buyABonusBackground:buyABonusTextContainer:freeSpinsCostValue'
  );
};

buyBonusPopup.onGameConfig = function (event) {
  buyBonusPopup.gameConfig = event;
  buyBonusPopup.init();
};

buyBonusPopup.onBalanceEvent = function (event) {
  buyBonusPopup.balance = event.data.balance;
};

buyBonusPopup.onClosePopup = function (buyBonus) {
  soundManager.play('buttonPressed');

  buyBonusPopup.open = false;

  if (buyBonus) {
    buyBonusPopup.onStartBonusSpin();
  } else {
    // Not buying a bonus, so reset
  }

  let reels = resourceManager.get('slotContainer:reelContainer');
  reels.alpha = 1.0;

  buyBonusPopup.container.visible = false;
  buyBonusPopup.callback(buyBonus);
};

buyBonusPopup.onStartBonusSpin = function () {
  gameData.winningsMeter.set(0);
  gameController.inBuyABonus = true;

  messageBus.post('game:modal', {});

  let stakeController = resourceManager.getController('stakeController');
  const numLines = gameData.gameConfig.slotConfig.coins;

  const bonusBuyStakes = buyBonusPopup.allStakesCombined;

  let baseStake = buyBonusPopup.convertToTotalStake(bonusBuyStakes[buyBonusPopup.combinedStakeIndex]);

  let stakes = stakeController.Stakes;
  let returnStake = stakes.find((stake) => stake === baseStake);

  if (!returnStake) {
    returnStake = stakes[0];
  }

  stakeController.requestChangeStake(returnStake);

  stakeController.requestChangeStake(baseStake, 'BONUS_BUY');

  const bpl = baseStake / numLines;
  const buyCost = buyBonusPopup.gameConfig.data.buyBonusCost;

  gameController.initNewSpin();

  gdk.startGame(
    {
      stake: baseStake * buyCost,
      numWinlines: numLines,
      bpl: bpl,
      metaData: {
        encore: false,
        buyABonus: true,
      },
    },
    function () {
      gdk.getNextGameOutcome(function () {});
    }
  );
};

buyBonusPopup.onClickedYes = function () {
  buyBonusPopup.onClosePopup(true);
};

buyBonusPopup.onClickedFreeSpins = function () {
  buyBonusPopup.onClosePopup(true);
};

buyBonusPopup.onClickedNo = function () {
  buyBonusPopup.open = false;

  messageBus.post('game:modal', {});

  buyBonusPopup.onClosePopup(false);
};

buyBonusPopup.onInfo = function () {};

buyBonusPopup.getFilesRequired = function (json) {
  return [];
};

resourceManager.registerObjectType(
  'buyBonusPopup',
  buyBonusPopup.create,
  buyBonusPopup.initialise,
  buyBonusPopup.getFilesRequired
);
